export default {
    namespaced: true,
    state() {
        return {
            owners: [],
            saveToOwnerAccount: false,
            filterBy: 'ONLY_TAX_ON_RENTAL_CHARGES',
            reportType: 'DOWNLOAD',
        };
    },
    getters: {
        owners: state => state.owners,
        saveToOwnerAccount: state => state.saveToOwnerAccount,
        filterBy: state => state.filterBy,
        reportType: state => state.reportType,
    },
    mutations: {
        setOwners(state, owners) {
            state.owners = owners;
        },
        setSaveToOwnerAccount(state, saveToOwnerAccount) {
            state.saveToOwnerAccount = saveToOwnerAccount;
        },
        setFilterBy(state, filterBy) {
            state.filterBy = filterBy;
        },
        setReportType(state, reportType) {
            state.reportType = reportType;
        },
    },
    actions: {
        async changeOwners({ commit }, value) {
            commit('setOwners', value);
        },
        async changeSaveToOwnerAccount({ commit }, value) {
            commit('setSaveToOwnerAccount', value);
        },
        async changeFilterBy({ commit }, value) {
            commit('setFilterBy', value);
        },
        async changeReportType({ commit }, value) {
            commit('setReportType', value);
        },
    },
};
